import * as React from "react";

import { cn } from "@/lib/utils";
import { isMobileViewport } from "@/hooks/use-mobile";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, autoFocus, ...props }, ref) => {
    return (
      <input
        type={type}
        // Never auto-focus on mobile — it pops the on-screen keyboard the moment
        // a screen/dialog opens, which is jarring.
        autoFocus={autoFocus && !isMobileViewport()}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
